import {Component, Input} from "@angular/core";
import {FormsModule} from "@angular/forms";
import {NgIf} from "@angular/common";

@Component({
  selector: 'app-annual-school-profiles-details-card',
  templateUrl: './annual-school-profiles-details-card.component.html',
  standalone: true,
  imports: [
    FormsModule,
    NgIf
  ],
  styleUrl: './annual-school-profiles-details-card.component.css'
})

export class AnnualSchoolProfilesDetailsCardComponent {
  @Input() name: string = '';
  @Input() email: string = '';
  @Input() isAdditional: boolean = false;
}
